import { httpRequest } from '@calendly/http-tools'

export const createExport = (eventId) => httpRequest(
  {
    url: '/api/exports',
    method: 'POST',
    data: { type: 'event_invitees', event_id: eventId }
  }
)
